import { FACharLimit } from "../../../constants";

export default function isLessThan46(fcity: any, fstate: any, fzip: any) {
  return fcity.length + fstate.length + fzip.length <= FACharLimit ? true : false;
}
